import type { AppRouteRecordRaw } from "./types/types";

import { productRoutes } from "@/app/router/core";
import { routeMatchesPartnership } from "@/app/router/utils/guards";
import { PARTNERSHIPS } from "@/features/partnership";
import type { Partnership } from "@/features/partnership";

export interface ProductPage {
  key: string
  label: string
  /** Sidebar section the page sits under. */
  group?: string
  partnerships: Partnership[]
}

export interface ProductPageCatalog {
  pages: ProductPage[]
  byRouteName: Map<string, ProductPage>
}

export const buildProductPageCatalog = (
  routes: ReadonlyArray<AppRouteRecordRaw>,
): ProductPageCatalog => {
  const pages: ProductPage[] = [];
  const byRouteName = new Map<string, ProductPage>();
  const byPageKey = new Map<string, ProductPage>();

  const visit = (routeList: ReadonlyArray<AppRouteRecordRaw>, group?: string): void => {
    for (const route of routeList) {
      if (route.children?.length) {
        visit(route.children, route.meta?.menuTitle ?? route.meta?.title);
        continue;
      }
      const key = route.meta?.pageKey;
      if (!key || typeof route.name !== "string" || !route.component || route.redirect) continue;

      const page = byPageKey.get(key) ?? {
        key,
        label: route.meta?.menuTitle ?? route.meta?.title ?? route.name,
        ...(group ? { group } : {}),
        partnerships: [],
      };
      for (const partnership of Object.values(PARTNERSHIPS)) {
        const available = routeMatchesPartnership(route.meta?.partnerships, partnership);
        if (available && !page.partnerships.includes(partnership)) {
          page.partnerships.push(partnership);
        }
      }
      if (!byPageKey.has(key)) {
        byPageKey.set(key, page);
        pages.push(page);
      }
      byRouteName.set(route.name, page);
    }
  };

  visit(routes);
  return { pages, byRouteName };
};

export const productPageCatalog = buildProductPageCatalog(productRoutes);
